export const PLAN_PRICES = {
  starter: 39,
  professional: 79,
  business: 149,
} as const;

export const PLAN_LIMITS = {
  starter: {
    pages: 2,
    submissions: 100,
    teamMembers: 5,
    campaigns: 1,
  },
  professional: {
    pages: 10,
    submissions: Infinity,
    teamMembers: 15,
    campaigns: 3,
  },
  business: {
    pages: Infinity,
    submissions: Infinity,
    teamMembers: Infinity,
    campaigns: Infinity,
  },
} as const;

export type UserPlan = 'starter' | 'professional' | 'business';
